import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
  IEnhancedTableMenuItem,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const headers: Record<string, EnhancedTableHeader> = {
  accounting_ChartOfAccounts_AccountID: {
    name: 'accounting_ChartOfAccounts_AccountID',
    title: 'Auxiliary ID',
    type: EnhancedTableHeaderType.Clickable,
    callback: () => undefined,
  },
  accounting_ChartOfAccounts_AccountName: {
    name: 'accounting_ChartOfAccounts_AccountName',
    title: 'Auxiliary Name',
    type: EnhancedTableHeaderType.Text,
  },
  accounting_ChartOfAccounts_AccountCurrency: {
    name: 'accounting_ChartOfAccounts_AccountCurrency',
    title: 'Currency',
    type: EnhancedTableHeaderType.Text,
  },
  accounting_ChartOfAccounts_createdOn: {
    name: 'accounting_ChartOfAccounts_createdOn',
    title: 'Created on',
    type: EnhancedTableHeaderType.Date,
  },
  viewHistory: {
    name: 'viewHistory',
    title: ' ',
    buttonLabel: 'View History',
    type: EnhancedTableHeaderType.Clickable,
    callback: () => undefined,
  },
};

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        company: {
          name: 'company',
          title: 'Company',
          type: FormInputTypes.newselect,
          value: filterValues?.company || null,
          placeholder: 'Company',
          triggerUpdate: true,
          selectOptions: { ...lovs.company },
        },
        accountSubCategory: {
          name: 'accountSubCategory',
          title: 'Ledger',
          type: FormInputTypes.newselect,
          value: filterValues?.accountSubCategory || null,
          placeholder: 'Select a ledger',
          triggerUpdate: true,
          selectOptions: { ...lovs.accountSubCategory },
        },
        createdOn: {
          name: 'createdOn',
          title: 'Created On',
          type: FormInputTypes.newdaterange,
          value: filterValues.createdOn || [],
          placeholder: 'Created On',
          triggerUpdate: true,
        },
      },
    },
  ];
  return newFilterSections;
}

export const actions: IEnhancedTableMenuItem[] = [
  {
    title: '+New Auxiliary',
    onClick: () => undefined,
    isEntity: false,
    isBulk: false,
    iconUrl: '',
  },
  {
    title: 'Import Account',
    onClick: () => undefined,
    isEntity: false,
    isBulk: true,
    iconUrl: '',
  },
];
